import { render, staticRenderFns } from "./meiriYt.vue?vue&type=template&id=0c64eb56&scoped=true"
import script from "./meiriYt.vue?vue&type=script&lang=js"
export * from "./meiriYt.vue?vue&type=script&lang=js"
import style0 from "./meiriYt.vue?vue&type=style&index=0&id=0c64eb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c64eb56",
  null
  
)

export default component.exports